<template>
    <div class="baike">
        <h1 style="margin-top: 20px;">企业百科——辰鳗科技集团</h1>
        <div style="padding: 20px;line-height:40px;text-align:left;margin:0 auto;" :style="{width: screenWidth >600 ?'50%':'100%'}">辰鳗科技集团有限公司
<div style="margin-bottom: 40px;">义项名：国内领先综合能源服务商</div>

辰鳗科技集团，是目前国内领先的综合能源服务商，成立于2020年，研发总部位于成都，在南京、天津、杭州、北京、广州、拉萨等地设有控股公司。辰鳗以“每一度，我们在服务”为企业使命，基于集团旗下小鳗管家综合能碳智控平台，以人工智能、物联网、多源异构能源算法、双碳能源管控等技术为支撑，建立“6+5+N”AI产品体系，全面赋能建筑综合能碳智控。
<div style="margin-top: 20px;"></div>

（一）企业简介
<div style="margin-bottom: 20px;"></div>
辰鳗科技集团，是目前国内领先的综合能源服务商，成立于2020年，研发总部位于成都，在南京、天津、杭州、北京、广州、拉萨等地设有控股公司，辰鳗的产品及服务截止2025年已经覆盖全球超过5个国家，超过181个城市，在中国大陆已服务超过118个城市，在全球管理了超过11.7万个工商业建筑。 
<div></div>
辰鳗以“每一度，我们在服务”为企业使命，基于集团旗下小鳗管家综合能碳智控平台，以人工智能、物联网、多源异构能源算法、双碳能源管控等技术为支撑，建立“6+5+N”AI产品体系，从能源数智化、综合节能、能源托管、虚拟电厂、微网协同，双碳服务6大方向，应用于公共建筑、商业建筑、住宅公寓、工业工厂、数据中心5个场景，提供“星能”产品系列，包括光伏运营、电力交易、电梯节能、空调节能、照明节能、综合水泵节能、储能监控、充电桩有序充电、能源数字化、综合微电网、水电费用管理、冷热费用管理等12个产品解决方案全面赋能建筑综合能碳智控。 
<div></div>
展望未来，辰鳗科技集团将以全球化为翼，以高质量发展为基，不断深化技术革新，积极拓宽服务领域，携手全球各地的合作伙伴，共同推动能源行业数字化转型与绿色低碳发展，为构建一个更加智慧、高效、可持续的零碳能源生态系统贡献辰鳗力量！
<div style="margin-top: 20px;"></div>

（二）发展历程
<div style="margin-bottom: 20px;"></div>
2020年6月 四川辰鳗科技有限公司成立 <div></div>
2021年7月 辰鳗智慧能源科技（天津）有限公司成立<div></div>
2022年3月　浙江辰鳗能源设备制造有限公司成立<div></div>
2023年3月　江苏辰鳗科技有限公司成立<div></div>
2023年3月  四川星小鳗能源有限公司成立<div></div>
2023年11月 西藏辰鳗科技有限公司成立<div></div>
2023年12月 广东辰鳗科技有限公司成立<div></div>
2024年1月 北京辰鳗低碳科技有限公司成立<div></div>
2024年11月 杭州辰鳗综能科技有限公司成立<div></div>
<div style="margin-top: 20px;"></div>
（三）公司荣誉
<div style="margin-bottom: 20px;"></div>
荣获四川省专精特新中小企业认定。<div></div>
荣获国家高新技术企业认定。<div></div>
荣获全国科技型中小企业。 <div></div>
荣获36氪创投平台「2023上半年最受投资人关注」企业服务Top10。</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            screenWidth: document.body.clientWidth,

        }
    },
    mounted() {
        console.log(this.screenWidth);
    },
    methods: {
        
    }
}
</script>

<style>
    .baike{
        font-size: 16px;
        height: 100vh;
        overflow: scroll;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/baike.vue